module.exports = __webpack_public_path__ + "static/media/emot2_on.7962d0d3.svg";